export default {"src":"/_next/static/media/ic-sentiment-3.e7e84b04.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};